<template>
    <div class="fill-height fill-width performing-update__bg">
        <v-container class="fill-height performing-update__container">
            <v-app-bar flat absolute color="rgba(0, 0, 0, 0)" class="py-14 d-flex" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''" >
                <v-img class="d-block" :class="$vuetify.breakpoint.xs ? 'mx-0' : ''" width="162" src="/logo_purple.png" />
            </v-app-bar>
            <v-row justify="center" align="center">
                <v-col cols="12" md="6" xl="5" class="d-flex flex-column align-center">
                    <v-avatar color="color-mix(in srgb, var(--v-primaryLight-base) 20%, white)" size="84" class="mb-5">
                        <v-icon size="50px" color="primary">
                            mdi-hammer-screwdriver
                        </v-icon>
                    </v-avatar>
                    <h1 class="performing-update__title mb-5">
                        Estamos realizando tareas de mantenimiento
                    </h1>
                    <p class="performing-update__text">
                        Inmatic volverá a estar activo en unos minutos.
                    </p>
                    <p class="performing-update__text">
                        Te pedimos disculpas por las molestias.
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "PerformingUpdate",

    components: {
    },

    data() {
        return {
        };
    },

    created() {
    },

    methods: {
    },

    computed: {
    },
};
</script>

<style scoped>
.performing-update__container {
    position: relative;
}

.performing-update__title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 45px;
    line-height: 50px;
    text-align: center;
    color: #66369B;
}

.performing-update__text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
}

@media screen and (min-width: 600px) {
    .performing-update__bg {
        background-image: url('/performing-update-bg-bottom.png'), url('/performing-update-bg-top.png');
        background-position: bottom left, top right;
    }
}
</style>